<template>
  <van-field v-model="shippingAddress.recipient" label="邮寄地址" placeholder="请选择邮寄地址" readonly :right-icon="'arrow'" @click="toAddressList">
    <template #input>
      <div v-if="shippingAddress.recipient">
        <p>{{ shippingAddress.recipient }} {{ shippingAddress.mobile }}</p>
        <p>{{ shippingAddress.provinceName }}/{{ shippingAddress.cityName }} {{ shippingAddress.address }}</p>
      </div>
      <div v-else>
        <p>请选择邮寄地址</p>
      </div>
    </template>
  </van-field>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'

export default {
  props: ['datas'],
  setup(props) {
    const { datas } = toRefs(props)
    const state = reactive({
      shippingAddress: datas
    })

    const router = useRouter()
    const toAddressList = () => router.push({ path: 'addressList' })

    return {
      ...toRefs(state),
      toAddressList
    }
  }
}
</script>

<style lang="sass" scoped></style>
